import { isEmpty } from 'ramda';
import { ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, filter, mergeMap, pluck, switchMap, withLatestFrom } from 'rxjs/operators';
import { fetchy } from '@bridebook/web/lib/fetchy';
import { appError } from '@bridebook/web/lib/app/actions';
import { selectMarketWithFallback } from '@bridebook/web/lib/i18n/selectors';
import {
  IFetchSearchSuggestionsAction,
  SearchActionTypes,
} from '@bridebook/web/lib/search/action-types';
import {
  fetchSearchSuggestionsAnalyticsDebounced,
  suggestionSuccess,
} from '@bridebook/web/lib/search/actions';
import { IEpic } from '@bridebook/web/lib/types';

export const suggestionsEpic: IEpic = (action$, { state$ }) =>
  action$.pipe(
    ofType(SearchActionTypes.FETCH_SEARCH_SUGGESTIONS),
    pluck<IFetchSearchSuggestionsAction, IFetchSearchSuggestionsAction['payload']>('payload'),
    filter(({ searchTerm }) => !isEmpty(searchTerm)),
    withLatestFrom(state$),
    mergeMap(([{ searchTerm, slug, size, lockCategory }, state]) => {
      const countryCode = selectMarketWithFallback(state).country;

      const promise = fetchy().post('/api/search/suggestions', null, {
        searchTerm,
        type: slug,
        size,
        lockCategory,
        countryCode,
      });

      return from(promise).pipe(
        switchMap((payload) =>
          of(fetchSearchSuggestionsAnalyticsDebounced(searchTerm), suggestionSuccess(payload)),
        ),
        catchError((error) => of(appError({ error, feature: 'Search' }))),
      );
    }),
  );
